// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".responsive-container__ratio--16-9{padding-top:56.25%}.responsive-container__ratio--4-3{padding-top:75%}.responsive-container__ratio--3-4{padding-top:133.334%}.responsive-container__ratio--1-1{padding-top:100%}.responsive-container__ratio--none{padding-top:0}.responsive-container__ratio>*{position:absolute;top:0;right:0;bottom:0;left:0}", ""]);
// Exports
module.exports = exports;
